// extracted by mini-css-extract-plugin
module.exports = {"button":"_25d45facb5--button--GVLSF","dark":"_25d45facb5--dark--gen_X"};